export default __webpack_public_path__ + "static/media/mist.61833c8c.svg";